import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'
import {Colors} from "../../theme/generated/Colors.ts";

const renderIcon = (color: string = Colors.Coral_moss_700) => (
    <path
        d="M9.66675 15.1667H5.08341V19.75M13.3334 7.83333H17.9167V3.25M4.70117 8.75312C5.21513 7.48102 6.07565 6.37862 7.18492 5.57121C8.29419 4.7638 9.60887 4.28356 10.9774 4.18547C12.3458 4.08737 13.7136 4.37512 14.9267 5.01606C16.1398 5.657 17.1479 6.62566 17.838 7.81145M18.2995 14.2473C17.7855 15.5194 16.925 16.6218 15.8158 17.4292C14.7065 18.2366 13.3931 18.7163 12.0247 18.8144C10.6562 18.9125 9.28731 18.6247 8.07422 17.9838C6.86113 17.3429 5.85234 16.3744 5.16219 15.1886"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const Refresh: React.FC<IconProps> = ({color, size}) => <IconWrapper {...{size, color, renderIcon}} />
